<template>
<div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
      <!-- <Toast style="margin-top: 35px" /> -->
      <form>
        <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
            <Dialog header="Account Master"  :visible.sync="displayBasic"
           :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
             <div class="p-field p-col-12 p-md-6">
                <label for="name">Name<span style="color:red">*</span></label>
                <InputText ref="name" v-if="!systemOnly" id="name" v-model.trim="accountName"/>
                <InputText ref="name" v-else  id="name" v-model.trim="accountName" disabled/>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="shortName" >Short Name</label>
                <InputText type="text" v-model.trim="shortName" id="shortName"/>
             </div>

             <div class="p-field p-col-12 p-md-6">
               <label for="head">Group<span style="color:red">*</span></label>
               <Dropdown v-if="!systemOnly" v-model="accountHead" :options="accountHeadLists" optionLabel="name" :filter="true" placeholder="Select Group"
               id="head"  @change="selectDrCrType(accountHead.id)" :showClear="true"/>
               <Dropdown v-else v-model="accountHead" :options="accountHeadLists" optionLabel="name" :filter="true" placeholder="Select Group"
               id="head"  @change="selectDrCrType(accountHead.id)" :showClear="true" disabled/>
             </div>
          <accountgroupdialog style="margin-top:1.3em" class="p-mt-5"  @set_data="set_data"/>
          <div class="p-field p-col-12 p-md-6">
            <label for="subHead">Sub Group</label>
            <Dropdown v-if="!systemOnly" id="subHead" v-model="accountSubHead" :options="accountSubGroupLists" optionLabel="name"
              :filter="true" placeholder="Select Sub Group" :showClear="true" />
              <Dropdown v-else id="subHead" v-model="accountSubHead" :options="accountSubGroupLists" optionLabel="name"
              :filter="true" placeholder="Select Sub Group" :showClear="true"  disabled/>
          </div>
          <accountsubgroupdialog style="margin-top:1.3em" class="p-mt-5" @set_data_subhead="set_data_subhead"/>
          <div class="p-field p-col-12 p-md-6">
            <label for="openingBalance" >Opening Balance</label>
            <InputText id="openingBalance" @keypress="isNumber($event)" v-model.number="openingBalance"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="accountType" >Dr/Cr Type</label>
            <select id="accountType" class="form-control" v-model="openingDrCr">
              <option selected disabled value="">Select Dr/Cr</option>
              <option  v-for="(drcr,ind) in dr_crList" :key="ind">{{drcr.openingDrCr}}</option>
            </select>
          </div>
        
        <div class="p-field p-col-12 p-md-6">
          <label for="status1">Status</label>
           <div class="p-field p-col-12 p-md-6">
            <RadioButton id="status1" name="ACTIVE" value="ACTIVE" v-model="status" />
            <label for="status1">Active</label>
            <RadioButton id="status2" name="INACTIVE" value="INACTIVE" v-model="status" />
            <label for="status2">Inactive</label>
         </div>
        </div>
         <div class="p-field p-col-12 p-md-6">
          <label for="status1">Cost Center Ledger</label>
          <div class="p-field p-col-12 p-md-6">
            <Checkbox id="city1"  name="city" v-model="enableCostCenter" :binary="true"/>
         </div>
         </div>
        </div>
        <template #footer>
          <Button class="p-button-raised" @click.prevent="addAccountMaster" :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-info" @click.prevent="saveAndNewAccountMaster" v-if="!editing" label="Add & New"/>
          <Button  @click.prevent="cancel" class="p-button-raised p-button-danger" label="Cancel">Cancel</Button>
        </template>
        </Dialog>
      </form>
    </div>
  </template>
<script>
  import Dropdown from 'primevue/dropdown'
  import Dialog from 'primevue/dialog'
  import RadioButton from 'primevue/radiobutton'
  import InputText from 'primevue/inputtext'
  import accountgroupdialog from './AccountGroupDialog.vue'
  import accountsubgroupdialog from './AccountSubGroupDialog.vue'
  import Button from 'primevue/button'
  import Checkbox from 'primevue/checkbox'
  export default {
    name: 'accountMaster',
    data() {
      return {
        accountName: '',
        accountSubHead: '',
        accountSubHeadId: '',
        accountHead: '',
        shortName: '',
        openingBalance: '',
        status: 'ACTIVE',
        openingDrCr: 'Dr',
        dr_crList: [
          {'openingDrCr': 'Dr'},
          {'openingDrCr': 'Cr'}
        ],
        displayBasic: false,
        editing: false,
        id: null,
        loading: false,
        accountSubGroupLists: [],
        reaccountSubGroupLists: [],
        systemOnly: false,
        enableCostCenter: false
      }
    },
    computed: {
      accountHeadLists() {
        return this.$store.state.accountHead.accountHeadDropList
      }
    },
    mounted() {
      this.accountSubHeadList()
      this.accountHeadList()
    },
    methods: {
      async addAccountMaster() {
        let resp = ''
        if (this.accountName.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
          return
        }
        if (this.accountHead === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select account group!', life: 10000})
          return
        }
        if (this.accountSubHead === undefined) {
          this.accountSubHead == null
          this.accountSubHeadId = 0
        } else {
          this.accountSubHeadId = this.accountSubHead.id
        }
        let accountMaster = {
          name: this.accountName,
          shortName: this.shortName,
          accountHeadId: this.accountHead.id,
          accountSubHeadId: this.accountSubHeadId,
          openingBalance: this.openingBalance,
          openingDrCr: this.openingDrCr,
          id: this.id,
          status: this.status,
          enableCostCenter: this.enableCostCenter
        }
        try {
          if (!this.editing) {
            this.loading = !this.loading
            resp = await this.$store.dispatch('createAccountMaster', accountMaster)
            this.$emit('set_account_master', resp.data.data)
            this.loading = false
          } else {
            this.loading = !this.loading
            resp = await this.$store.dispatch('updateAccountMaster', accountMaster)
            this.loading = false
          }
        } catch (e) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
          this.loading = false
          return
        }

        this.closeBasic()
        this.responseValue(resp)
      },
      async saveAndNewAccountMaster() {
        let response = ''
        if (this.accountName.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Account Name cannot be empty!', life: 10000})
          return
        }
        if (this.accountHead === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select account group!', life: 10000})
          return
        }
        let accountMaster = {
          name: this.accountName,
          shortName: this.shortName,
          accountSubHeadId: this.accountSubHead.id,
          accountHeadId: this.accountHead.id,
          openingBalance: this.openingBalance,
          openingDrCr: this.openingDrCr,
          status: this.status,
          enableCostCenter: this.enableCostCenter
        }
        try {
          this.loading = !this.loading
          response = await this.$store.dispatch('createAccountMaster', accountMaster)
          this.loading = false
        } catch (e) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
          this.loading = false
          return
        }

        this.responseValue(response)
        this.focusAfterSave()
      },
      responseValue(response) {
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
          this.reset()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
          this.reset()
        }
      },
      async accountSubHeadList() {
        try {
          let resp = await this.$store.dispatch('accountSubHeadDropDown')
          this.accountSubGroupLists = resp.data.data
          this.reaccountSubGroupLists = resp.data.data
        } catch (e) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 10000})
          return
        }
      },
      async accountHeadList() {
        await this.$store.dispatch('accountHeadDropDown')
      },
      updateAccountMaster(data) {
        this.editing = !this.editing
        this.displayBasic = !this.displayBasic
        this.accountName = data.name
        this.shortName = data.shortName
        this.accountSubHead = data.accountSubHead
        this.openingBalance = data.openingBalance
        this.accountHead = data.accountHead
        this.status = data.status
        this.enableCostCenter = data.enableCostCenter
        if (data.openingBalance === 0) {
          this.openingDrCr = 'Dr'
        } else {
          this.openingDrCr = data.openingDrCr
        }
        this.status = data.status
        this.id = data.id
        this.systemOnly = data.isSystemOnly
        this.selectDrCrType(this.accountHead.id)
      },
      set_data(data) {
        this.accountHead = data
        this.selectDrCrType(data.id)
      },
      set_data_subhead(data) {
        this.accountSubHead = data
        this.selectDrCrType(data.id)
      },
      selectDrCrType(id) {
        let filteredSubGroup = 0
        if (this.accountSubGroupLists.length === 0 || filteredSubGroup === 0) {
          this.accountSubGroupLists = this.reaccountSubGroupLists
        }
        if (!this.editing) {
          if (this.accountHead.natureName === 'Assets' || this.accountHead.natureName === 'Expenses') {
            this.openingDrCr = 'Dr'
          } else if (this.accountHead.natureName === 'Liabilities' || this.accountHead.natureName === 'Incomes') {
            this.openingDrCr = 'Cr'
          }
        }
        filteredSubGroup = this.accountSubGroupLists.filter(subHead => subHead.headId === id)
        this.accountSubGroupLists = filteredSubGroup
      },
      cancel() {
        this.reset()
        this.closeBasic()
      },
      focusAfterSave() {
        this.$refs.name.focus()
      },
      reset() {
        this.accountSubHead = ''
        this.accountHead = ''
        this.accountName = ''
        this.shortName = ''
        this.openingBalance = ''
        this.accountSubHeadId = ''
        this.openingDrCr = ''
        this.editing = false
        this.accountSubGroupList = this.reaccountSubGroupLists
        this.systemOnly = false
        // this.closeBasic()
      },
      isNumber(evt) {
        evt = window.event
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      openBasic() {
        this.displayBasic = true
      },
      closeBasic() {
        this.displayBasic = false
      },
      deleteMessage(value) {
        this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
      }
    },
    components: {
      Dropdown,
      Dialog,
      RadioButton,
      InputText,
      accountgroupdialog,
      accountsubgroupdialog,
      Button,
      Checkbox
    }
  }
  </script>
  <style scoped src="@../../../static/css/dialogEntry.css">

  </style>



// WEBPACK FOOTER //
// AccountMasterDialog.vue?182bf09a